import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { CLICKHOUSE } from "../../Constants"

function ZdqClickHouseConnectorStatus() {
    return <ZdqConnectorStatus vendor={CLICKHOUSE}></ZdqConnectorStatus>
}

export default ZdqClickHouseConnectorStatus